import { StorageCookie } from 'reactor/common';

import { C } from 'common';

const { COOKIE_DOMAIN, STORAGE, URL } = C;

export default async () => {
  [STORAGE.AGENCY, STORAGE.CODE].map(cookie => StorageCookie.set(cookie, null, COOKIE_DOMAIN));
  window.location = URL.AGENCY;
};
